// Add all JS development here
jQuery(function ($) {
  $(document).ready(function () {

    // <- Carousel functions ->
    (function () {
      // Hide Offcanvace when click nav link
      $("#mobileMenu a.nav-link").on("click", function () {
        $("#mobileMenu").offcanvas("hide");
      });


      $(".trust-us-slider").owlCarousel({
        loop: true,
        margin: 20,
        nav: false,
        dots: false,
        center: true,
        autoplay: true,
        autoplayTimeout: 6000,
        autoplayHoverPause: false,
        responsive: {
          0: {
            items: 1
          },
          600: {
            items: 2
          },
          1000: {
            items: 3
          }
        }
      });

      

    // Testimonials: autoplay control (docked in the section header).
    let trustSlider = $(".trust-us-slider");
    let trustPlaying = true;

    function setTrustPlaying(playing) {
        trustPlaying = playing;
        const $btn = $(".trust-play-pause-btn");
        if (playing) {
            trustSlider.trigger("play.owl.autoplay", [6000]);
            $btn.find("i").removeClass("ri-play-circle-line").addClass("ri-pause-circle-line");
            $btn.attr("aria-label", "Pause testimonials autoplay");
        } else {
            trustSlider.trigger("stop.owl.autoplay");
            $btn.find("i").removeClass("ri-pause-circle-line").addClass("ri-play-circle-line");
            $btn.attr("aria-label", "Play testimonials autoplay");
        }
    }

    $(".trust-play-pause-btn").on("click", function () {
        setTrustPlaying(!trustPlaying);
    });

    // Manual interaction restarts the autoplay countdown so the carousel
    // doesn't advance right after the user moved it themselves.
    function resetTrustTimer() {
        if (!trustPlaying) return;
        trustSlider.trigger("stop.owl.autoplay");
        trustSlider.trigger("play.owl.autoplay", [6000]);
    }

    $(".trust-us-section .slider-prev-btn").on("click", function () {
        trustSlider.trigger("prev.owl.carousel", [300]);
        resetTrustTimer();
    });

    $(".trust-us-section .slider-next-btn").on("click", function () {
        trustSlider.trigger("next.owl.carousel", [300]);
        resetTrustTimer();
    });

    trustSlider.on("dragged.owl.carousel", resetTrustTimer);

    // Testimonials: quotes are clamped to a fixed number of lines; "More"
    // expands the full review in place (and pauses the carousel so it can
    // be read). Delegated so Owl's cloned slides work too.
    $(document).on("click", ".trust-us-slider .review-more-btn", function () {
        const $btn = $(this);
        const $card = $btn.closest(".card");
        const expanded = $card.toggleClass("expanded").hasClass("expanded");
        $btn.text(expanded ? "Less" : "More").attr("aria-expanded", String(expanded));
        if (expanded && trustPlaying) {
            setTrustPlaying(false);
        }
    });

    // Hide the More button on reviews short enough to never clamp.
    function hideNonOverflowingMoreButtons() {
        $(".trust-us-slider .card").each(function () {
            const $card = $(this);
            if ($card.hasClass("expanded")) return;
            const text = $card.find("p.card-text")[0];
            if (text) {
                $card.find(".review-more-btn").toggleClass("is-hidden", text.scrollHeight <= text.clientHeight + 1);
            }
        });
    }
    trustSlider.on("initialized.owl.carousel resized.owl.carousel", function () {
        setTimeout(hideNonOverflowingMoreButtons, 100);
    });
    setTimeout(hideNonOverflowingMoreButtons, 800);

      // Advantage Slider
      let advantageSlider = $(".advantage-slider").owlCarousel({
        loop: true,
        margin: 20,
        nav: false,
        dots: false,
        center: true,
        stagePadding: 120,
        autoplay: true,
        autoplayTimeout: 6000,
        autoplayHoverPause: false,
        responsive: {
          // No autoHeight anywhere: the stage height animating per-slide made
          // the controls below bounce vertically. Slides are equalized in CSS
          // instead (flex stage in _home.scss), so the stage height is
          // constant and the controls stay put.
          0: {
            items: 1,
            stagePadding: 10
          },
          600: {
            items: 1,
            stagePadding: 10
          },
          1000: {
            items: 1,
            stagePadding: 300
          }
        }
      });

      // Advantage slider controls: prev / play-pause toggle / next.
      let advantagePlaying = true;

      function setAdvantagePlaying(playing) {
        advantagePlaying = playing;
        const $btn = $(".advantage-play-pause-btn");
        if (playing) {
          advantageSlider.trigger("play.owl.autoplay", [6000]);
          $btn.find("i").removeClass("ri-play-circle-line").addClass("ri-pause-circle-line");
          $btn.attr("aria-label", "Pause slider autoplay");
        } else {
          advantageSlider.trigger("stop.owl.autoplay");
          $btn.find("i").removeClass("ri-pause-circle-line").addClass("ri-play-circle-line");
          $btn.attr("aria-label", "Play slider autoplay");
        }
      }

      $(".advantage-play-pause-btn").on("click", function () {
        setAdvantagePlaying(!advantagePlaying);
      });

      // Manual interaction restarts the autoplay countdown so the carousel
      // doesn't advance right after the user moved it themselves.
      function resetAdvantageTimer() {
        if (!advantagePlaying) return;
        advantageSlider.trigger("stop.owl.autoplay");
        advantageSlider.trigger("play.owl.autoplay", [6000]);
      }

      $(".advantage-section .slider-prev-btn").on("click", function () {
        advantageSlider.trigger("prev.owl.carousel", [300]);
        resetAdvantageTimer();
      });

      $(".advantage-section .slider-next-btn").on("click", function () {
        advantageSlider.trigger("next.owl.carousel", [300]);
        resetAdvantageTimer();
      });

      advantageSlider.on("dragged.owl.carousel", resetAdvantageTimer);

      const $videoModal = $("#videoModal");
      const $videoIframe = $("#videoIframe");

      // Use passive event listeners for touch events if applicable
      $videoModal.on("show.bs.modal", function (event) {
        const button = $(event.relatedTarget);
        const videoUrl = button.data("video-url");

        if (videoUrl) {
          // Check for YouTube URL patterns
          if (
            videoUrl.includes("youtube.com") ||
            videoUrl.includes("youtu.be")
          ) {
            let embedUrl;

            // Handle youtube.com/watch?v= format
            if (videoUrl.includes("youtube.com/watch?v=")) {
              const videoId = new URL(videoUrl).searchParams.get("v");
              embedUrl = `https://www.youtube.com/embed/${videoId}`;
            }
            // Handle youtu.be/ format
            else if (videoUrl.includes("youtu.be/")) {
              const videoId = videoUrl.split("youtu.be/")[1].split("?")[0];
              embedUrl = `https://www.youtube.com/embed/${videoId}`;
            }
            // If it's already an embed URL
            else if (videoUrl.includes("youtube.com/embed/")) {
              embedUrl = videoUrl;
            }

            // Add autoplay parameter
            if (embedUrl) {
              embedUrl +=
                (embedUrl.includes("?") ? "&" : "?") +
                "autoplay=1&enablejsapi=1";
              $videoIframe.attr("src", embedUrl);
            }
          } else {
            // For non-YouTube URLs, just use as-is
            $videoIframe.attr("src", videoUrl);
          }
        }
      });

      $videoModal.on("hidden.bs.modal", function () {
        $videoIframe.attr("src", ""); // Stop video on close
      });

      // Meet-the-CEO: play the demo inline in the poster frame instead of a
      // modal. The link carries the embed URL in data-video-url.
      $(".meet-ceo-body .open-video").on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        const $link = $(this);
        const videoUrl = $link.data("video-url");
        if (!videoUrl) return;

        const embedUrl =
          videoUrl + (videoUrl.includes("?") ? "&" : "?") + "autoplay=1&rel=0";
        const $body = $link.closest(".meet-ceo-body");
        if ($body.find(".ceo-inline-video").length) return;

        const $player = $(
          '<div class="ceo-inline-video ratio ratio-16x9"></div>'
        ).append(
          $("<iframe>", {
            src: embedUrl,
            title: "SAMstream demo video",
            allow: "autoplay; encrypted-media",
            allowfullscreen: ""
          })
        );

        $body.find(".ceo-media-frame").hide();
        $body.append($player);
      });

      // Blog article: play the video inline in the hero poster frame, same
      // pattern as the CEO video. The modal is only used on the blog archive.
      $(".article-media .article-poster").on("click", function (e) {
        e.preventDefault();
        const $link = $(this);
        const videoUrl = $link.data("video-url");
        if (!videoUrl) return;

        const embedUrl =
          videoUrl + (videoUrl.includes("?") ? "&" : "?") + "autoplay=1&rel=0";
        const $media = $link.closest(".article-media");
        if ($media.find(".article-inline-video").length) return;

        const $player = $(
          '<div class="article-inline-video ratio ratio-16x9"></div>'
        ).append(
          $("<iframe>", {
            src: embedUrl,
            title: "Video player",
            allow: "autoplay; encrypted-media",
            allowfullscreen: ""
          })
        );

        $link.hide();
        $media.append($player);
      });

    })();

    AOS.init({
      duration: 1500,
      once: true
    });
  });
});

// Press-badge iframe (home page): resize to the height the embedded page
// reports via postMessage. Factored out of an inline script in the home
// template.
window.addEventListener("message", function (event) {
  if (event.data && event.data.badgeHeight) {
    const badgeIframe = document.getElementById("badgeIframe");
    if (badgeIframe) {
      badgeIframe.style.height = event.data.badgeHeight + "px";
    }
  }
});


const items = document.querySelectorAll(".accordion button");

function toggleAccordion() {
  const itemToggle = this.getAttribute("aria-expanded");

  for (i = 0; i < items.length; i++) {
    items[i].setAttribute("aria-expanded", "false");
  }

  if (itemToggle == "false") {
    this.setAttribute("aria-expanded", "true");
  }
}

items.forEach((item) => item.addEventListener("click", toggleAccordion));


document.addEventListener("DOMContentLoaded", function () {
  // Make sure GSAP and ScrollTrigger are registered
  if (typeof gsap !== "undefined" && typeof ScrollTrigger !== "undefined") {
    // Register ScrollTrigger plugin
    gsap.registerPlugin(ScrollTrigger);

    // Configure GSAP
    gsap.config({
      nullTargetWarn: false // Suppress some warnings
    });

    // Only initialize timeline animations if the timeline section exists
    if (document.querySelector(".timeline-section")) {
      initTimelineAnimations();
    }
  }
});

function initTimelineAnimations() {
  // Timeline header animation - only if element exists
  const timelineHeaders = document.querySelectorAll(
    ".color-timeline-hero-content h2"
  );
  if (timelineHeaders.length > 0) {
    gsap.from(timelineHeaders, {
      y: 50,
      opacity: 0,
      duration: 1,
      stagger: 0.3,
      ease: "power3.out",
      scrollTrigger: {
        trigger: ".timeline-hero",
        start: "top 80%",
        toggleActions: "play none none none"
      }
    });
  }

  // Timeline line animation - only if element exists
  const timelineElement = document.querySelector(".timeline");
  if (timelineElement) {
    gsap.fromTo(
      timelineElement,
      { "--timeline-line-height": "0%" },
      {
        "--timeline-line-height": "68%",
        duration: 1.5,
        ease: "power3.inOut",
        scrollTrigger: {
          trigger: ".timeline",
          start: "top 70%",
          end: "bottom 20%",
          scrub: 1
        }
      }
    );
  }

  // Timeline items animation - only if elements exist
  const timelineItems = document.querySelectorAll(".timeline-list-item");
  if (timelineItems.length > 0) {
    timelineItems.forEach((item, index) => {
      const content = item.querySelector(".content");
      const timeElement = item.querySelector(".time");

      if (!content || !timeElement) return; // Skip if necessary elements are missing

      // Create a timeline for each item
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: item,
          start: "top 75%",
          toggleActions: "play none none none"
        }
      });

      // Different animations based on odd or even items
      const direction = index % 2 === 0 ? -50 : 50;

      tl.fromTo(
        item,
        { x: direction, opacity: 0 },
        { x: 0, opacity: 1, duration: 0.7, ease: "power3.out" }
      )
        .fromTo(
          content,
          { y: 20, opacity: 0 },
          { y: 0, opacity: 1, duration: 0.5, ease: "power2.out" },
          "-=0.3"
        )
        .fromTo(
          timeElement,
          { scale: 0.8, opacity: 0 },
          { scale: 1, opacity: 1, duration: 0.5, ease: "back.out(1.7)" },
          "-=0.2"
        );

      // Add a reveal animation for list items if they exist
      const listItems = item.querySelectorAll(".content-list li");
      if (listItems.length > 0) {
        tl.fromTo(
          listItems,
          { y: 15, opacity: 0 },
          { y: 0, opacity: 1, stagger: 0.1, duration: 0.4, ease: "power2.out" },
          "-=0.2"
        );
      }
    });
  }

  // Radial background animations - only if elements exist
  const radials = document.querySelectorAll(".radial-section");
  if (radials.length > 0) {
    radials.forEach((radial, index) => {
      gsap.fromTo(
        radial,
        { scale: 0.5, opacity: 0 },
        {
          scale: 1,
          opacity: 0.7,
          duration: 1.5,
          delay: index * 0.2,
          ease: "power2.out",
          scrollTrigger: {
            trigger: ".timeline-section",
            start: "top 70%",
            toggleActions: "play none none reverse"
          }
        }
      );
    });
  }
}


// Countdown Timer Module
const CountdownTimer = (function () {
  const ACTIVE_CLASS = "countdown-active";
  const BASE = "https://logwork.com/widget/countdown";
  const LOGWORK_ORIGIN = new URL(BASE).origin;

  const knownUids = new Set();

  function init() {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", initAll);
    } else {
      initAll();
    }
  }

  function initAll() {
    const timers = document.querySelectorAll(".countdown-timer");
    for (let i = 0; i < timers.length; i++) {
      initTimer(timers[i]);
    }
  }

  function randInt(minInclusive, maxInclusive) {
    return (
      Math.floor(Math.random() * (maxInclusive - minInclusive + 1)) +
      minInclusive
    );
  }

  function getData(el, name) {
    const v = el && el.dataset ? el.dataset[name] : undefined;
    return typeof v === "undefined" ? "" : String(v);
  }

  function buildQuery(pairs) {
    return pairs
      .filter(([, v]) => v !== "" && v != null)
      .map(
        ([k, v]) => encodeURIComponent(k) + "=" + encodeURIComponent(String(v))
      )
      .join("&");
  }

  function computeTargetTimestring(anchorEl) {
    // Get values from data attributes or use defaults - THIS WAS THE ISSUE
    const timezone = getData(anchorEl, "timezone") || "America/Los_Angeles";
    const targetWeekday = parseInt(getData(anchorEl, "weekday") || "0", 10);
    const targetHour = parseInt(getData(anchorEl, "hour") || "15", 10);
    const targetMinute = parseInt(getData(anchorEl, "minute") || "0", 10);

    const now = new Date();
    const fmt = new Intl.DateTimeFormat("en-US", {
      timeZone: timezone, // Use the local variable, not TIMEZONE constant
      hour12: false,
      weekday: "short",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit"
    });

    const parts = Object.fromEntries(
      fmt.formatToParts(now).map((p) => [p.type, p.value])
    );

    const dayIndex = {
      Sun: 0,
      Mon: 1,
      Tue: 2,
      Wed: 3,
      Thu: 4,
      Fri: 5,
      Sat: 6
    }[parts.weekday];

    const nowH = parseInt(parts.hour, 10);
    const nowM = parseInt(parts.minute, 10);

    let addDays = (targetWeekday - dayIndex + 7) % 7;
    if (addDays === 0) {
      if (nowH > targetHour || (nowH === targetHour && nowM >= targetMinute)) {
        addDays = 7;
      }
    }

    const base = new Date(
      Date.UTC(
        Number(parts.year),
        Number(parts.month) - 1,
        Number(parts.day) + addDays
      )
    );

    const Y = base.getUTCFullYear();
    const M = String(base.getUTCMonth() + 1).padStart(2, "0");
    const D = String(base.getUTCDate()).padStart(2, "0");
    const hh = String(targetHour).padStart(2, "0");
    const mm = String(targetMinute).padStart(2, "0");

    return `${Y}-${M}-${D} ${hh}:${mm}`;
  }

  function initTimer(anchorEl) {
    if (!anchorEl || anchorEl.classList.contains(ACTIVE_CLASS)) return;

    anchorEl.style.position = "relative";
    anchorEl.style.overflow = "hidden";
    anchorEl.style.display = "inline-block";

    const textRaw = (anchorEl.textContent || "").trim();
    const backgroundRaw = getData(anchorEl, "background");
    const widthRaw = getData(anchorEl, "width");
    const styleParamRaw = getData(anchorEl, "style");
    const languageRaw = getData(anchorEl, "language");
    const textColorRaw = getData(anchorEl, "textcolor");
    const digitsColorRaw = getData(anchorEl, "digitscolor");
    const unitsColorRaw = getData(anchorEl, "unitscolor");

    // Get timezone from the element for use in params
    const timezone = getData(anchorEl, "timezone") || "America/Los_Angeles";

    const widthNum = Number.parseInt(widthRaw, 10);
    const hasFixedWidth = Number.isFinite(widthNum) && widthNum > 0;
    if (!hasFixedWidth) anchorEl.style.width = "100%";

    const uid = randInt(1, 1_000_000);
    anchorEl.id = "time_countdown_" + uid;
    knownUids.add(String(uid));

    const pageUrl = window.location.origin + window.location.pathname;
    const computedDate = computeTargetTimestring(anchorEl); // Pass anchorEl to function

    const params = buildQuery([
      ["text", textRaw],
      ["timezone", timezone], // Use the local variable
      ["width", hasFixedWidth ? String(widthNum) : ""],
      ["style", styleParamRaw],
      ["uid", String(uid)],
      ["loc", anchorEl.getAttribute("href") || ""],
      ["language", languageRaw],
      ["textcolor", textColorRaw],
      ["background", backgroundRaw],
      ["date", computedDate],
      ["digitscolor", digitsColorRaw],
      ["unitscolor", unitsColorRaw],
      ["url", pageUrl]
    ]);

    const iframe = document.createElement("iframe");
    iframe.id = "countdown_iframe_" + uid;
    iframe.src = `${BASE}/?${params}`;
    iframe.title = "Countdown";
    iframe.setAttribute("scrolling", "no");
    iframe.setAttribute("allowtransparency", "true");
    iframe.setAttribute("frameborder", "0");
    iframe.style.width = hasFixedWidth ? widthNum + "px" : "100%";
    iframe.style.height = "1px";
    iframe.style.visibility = "hidden";
    iframe.style.backgroundColor = "transparent";
    iframe.style.border = "none";
    iframe.style.margin = "0";

    anchorEl.innerHTML = "";
    anchorEl.appendChild(iframe);

    if (anchorEl.getAttribute("href")) {
      anchorEl.target = "_blank";
      anchorEl.rel = "noopener noreferrer";
    }

    const overlay = document.createElement("div");
    overlay.id = "ovd_" + uid;
    overlay.style.width = "1px";
    overlay.style.height = "1px";
    overlay.style.position = "absolute";
    overlay.style.left = "0";
    overlay.style.top = "0";
    overlay.style.opacity = "0";
    overlay.style.pointerEvents = "none";
    anchorEl.appendChild(overlay);

    anchorEl.addEventListener("mouseover", function () {
      sendMsg(anchorEl, "button_over");
    });

    anchorEl.addEventListener("mouseout", function () {
      sendMsg(anchorEl, "button_out");
    });

    watchWidth(anchorEl);

    addClass(anchorEl, ACTIVE_CLASS);
  }

  // The widget reports its height once, for the width it had at that moment.
  // If the anchor reflows afterwards (rotation, late layout/font settling)
  // the pinned height goes stale and renders as dead space under the
  // circles. Re-ask the widget for its size whenever the width changes.
  function watchWidth(anchorEl) {
    if (typeof ResizeObserver !== "function") return;

    let lastWidth = anchorEl.getBoundingClientRect().width;
    let pending = null;

    const observer = new ResizeObserver(function (entries) {
      const width = entries[entries.length - 1].contentRect.width;
      if (Math.abs(width - lastWidth) < 1) return;
      lastWidth = width;
      if (pending) clearTimeout(pending);
      pending = setTimeout(function () {
        pending = null;
        sendMsg(anchorEl, "js_countdown_size");
      }, 150);
    });

    observer.observe(anchorEl);
  }

  function sendMsg(el, payload) {
    const f = el.getElementsByTagName("iframe")[0];
    if (f && f.contentWindow)
      f.contentWindow.postMessage(payload, LOGWORK_ORIGIN);
  }

  function addClass(el, cls) {
    if (!el) return;
    if (el.classList) {
      if (!el.classList.contains(cls)) el.classList.add(cls);
    } else {
      var classes = (el.className || "").split(/\s+/);
      if (classes.indexOf(cls) === -1) {
        classes.push(cls);
        el.className = classes.join(" ").trim();
      }
    }
  }

  // Message event listener
  function setupMessageListener() {
    window.addEventListener(
      "message",
      function (evt) {
        if (!evt) return;
        if (evt.origin !== LOGWORK_ORIGIN) return;

        const data = evt.data;
        if (typeof data !== "object" || data === null) return;

        const eventId = data.event_id;
        const uid = data.uid != null ? String(data.uid) : null;

        if (!eventId || !uid || !knownUids.has(uid)) return;

        const iframe = document.getElementById("countdown_iframe_" + uid);
        const anchor = document.getElementById("time_countdown_" + uid);
        if (!iframe || !anchor) return;
        if (evt.source !== iframe.contentWindow) return;

        if (eventId === "js_countdown_show") {
          const page = typeof data.page === "string" ? data.page : "";
          if (page === "not_found") {
            anchor.dataset.notFound = "1";
            iframe.style.visibility = "hidden";
            iframe.setAttribute("aria-hidden", "true");
            return;
          }

          iframe.style.visibility = "visible";
          iframe.removeAttribute("aria-hidden");

          const widthRaw = anchor.dataset.width;
          const widthNum = Number.parseInt(widthRaw, 10);
          if (Number.isFinite(widthNum) && widthNum > 0) {
            iframe.style.width = widthNum + "px";
          } else {
            iframe.style.width = "100%";
          }

          sendMsg(anchor, "js_countdown_size");

          // One delayed re-measure: the first report can be computed against
          // a layout that hasn't finished settling, which pins a stale
          // height even though the width never changes again.
          setTimeout(function () {
            sendMsg(anchor, "js_countdown_size");
          }, 1500);
        }

        if (eventId === "time_countdown_size") {
          if (anchor.dataset.notFound === "1") {
            iframe.style.visibility = "hidden";
            iframe.setAttribute("aria-hidden", "true");
            return;
          }

          const w = Number.isFinite(+data.width) ? +data.width : null;
          const h = Number.isFinite(+data.height) ? +data.height : null;

          if (w != null && h != null) {
            const widthRaw = anchor.dataset.width;
            const widthNum = Number.parseInt(widthRaw, 10);
            if (Number.isFinite(widthNum) && widthNum > 0) {
              iframe.style.width = widthNum + "px";
            } else {
              iframe.style.width = "100%";
            }

            anchor.style.height = h + "px";
            iframe.style.height = h + "px";
            iframe.style.visibility = "visible";
            iframe.removeAttribute("aria-hidden");

            const overlay = document.getElementById("ovd_" + uid);
            if (overlay) {
              overlay.style.width = w + 6 + "px";
              overlay.style.height = h + 6 + "px";
            }
          }
        }
      },
      false
    );
  }

  // Public API
  return {
    init: function () {
      init();
      setupMessageListener();
    }
  };
})();

// Initialize countdown timer when DOM is ready
document.addEventListener("DOMContentLoaded", function () {
  CountdownTimer.init();
});

